import { Button } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  onClick: () => void;
  disabled: boolean;
  isExplanationState: boolean;
  isVideoQuestionState: boolean;
  isVideoQuestion: boolean;
  isAssessment: boolean;
}

export const StartRecordingButton:React.FC<IProps> = ({
  onClick, disabled, isExplanationState, isVideoQuestionState, isVideoQuestion, isAssessment,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      className={`myinterview-widget-recording-action-button ${isVideoQuestionState ? 'myinterview-widget-recording-action-button--video-question' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {t(`buttons.${isExplanationState || isAssessment ? 'btn_start_assessment' : 'btn_start_recording'}`)}
    </Button>
  );
};
